import { useEffect, useState } from 'react';
import { getConfigurations } from 'api/configurations';

export const DEFAULT_LIST_SIZE_SETTING = 'Default List Size';
export const FALLBACK_LIST_SIZE = 10;

/**
 * How many rows a list shows before the reader pages, as set in the settings.
 *
 * The size used to be whatever the page's own options started with, so
 * changing it meant editing every page; the setting is one place a user can
 * change it for all of them. A page that names its own options still offers
 * them, and this size joins them so the reader can page back to a shorter
 * list.
 */
export const useDefaultListSize = (pageOptions) => {
  const fallback = pageOptions?.length ? parseInt(pageOptions[0], 10) : FALLBACK_LIST_SIZE;
  const [listSize, setListSize] = useState(fallback);

  useEffect(() => {
    let abandoned = false;
    getConfigurations({ 'name[eq]': DEFAULT_LIST_SIZE_SETTING })
      .then(({ data }) => {
        const configured = parseInt(data?.[0]?.fix_value, 10);
        if (!abandoned && configured > 0) {
          setListSize(configured);
        }
      })
      .catch(() => {
        // the setting is a convenience; a list still pages without it
      });
    return () => {
      abandoned = true;
    };
  }, []);

  return listSize;
};

/** The page's own row-count options, with the configured size among them. */
export const listSizeOptions = (pageOptions, listSize) => {
  const options = (pageOptions || []).map((option) => parseInt(option, 10));
  return options.includes(listSize) ? options : [...options, listSize].sort((a, b) => a - b);
};
